import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../constants/path';
import { HAS_INSTANT_DISCOUNT } from '../constants/ebon';
import { PAYMENT_THRESHOLD, HIDE_ALO, STATIC_ROOT } from '../constants';

import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import LocalizedNavLink from './router/LocalizedNavLink';

import './StepsComponent.scss';

class StepsComponent extends React.Component {
    getSteps = () => {
        const {
            i18nOnline,
            i18nOffline,
            i18nEbon,
            BRAND_NAME,
            BRAND_NAME_ALT,
            isOffline,
            showAloOnly,
            isEbon
        } = this.props;

        if (isOffline) {
            return (
                <div className="offline-bloc">
                    {!HIDE_ALO && !showAloOnly && <h3>{i18nOffline.ALO_TITLE}</h3>}
                    {!HIDE_ALO && (
                        <div className="offline-row">
                            <div className="cmt-ca-marche-bloc">
                                <img
                                    alt="Picto bag"
                                    src={`${STATIC_ROOT}/HowItWorkPicoBag.png`}
                                    width="62"
                                    height="62"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(i18nOffline.ALO_STEP1)}
                                        <LocalizedNavLink
                                            to={PATH.ACCOUNT_PATH}
                                            title={i18nOffline.ALO_STEP1_1}>
                                            {i18nOffline.ALO_STEP1_1}
                                        </LocalizedNavLink>
                                    </p>
                                </div>
                            </div>
                            <div className="cmt-ca-marche-bloc">
                                <img
                                    alt="heart hand picto"
                                    src={`${STATIC_ROOT}/PictoHeartHand.png`}
                                    width="62"
                                    height="62"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.ALO_STEP2,
                                            BRAND_NAME_ALT
                                        )}
                                        <LocalizedNavLink
                                            to={PATH.ALO_PATH}
                                            title={i18nOffline.ALO_STEP2_1}>
                                            {i18nOffline.ALO_STEP2_1}
                                        </LocalizedNavLink>
                                    </p>
                                </div>
                            </div>
                            <div className="cmt-ca-marche-bloc">
                                <img
                                    alt="heart hand picto"
                                    src={`${STATIC_ROOT}/PictoHeartHand.png`}
                                    width="62"
                                    height="62"
                                />
                                <div className="texte">
                                    <p>
                                        {convertHtmlToReactDomWithParams(
                                            i18nOffline.ALO_STEP3,
                                            PAYMENT_THRESHOLD
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {!showAloOnly && (
                        <React.Fragment>
                            {!HIDE_ALO && <h3>{i18nOffline.FT_TITLE}</h3>}
                            <div className="offline-row">
                                <div className="cmt-ca-marche-bloc">
                                    <img
                                        alt="Picto bag"
                                        src={`${STATIC_ROOT}/HowItWorkPicoBag.png`}
                                        width="62"
                                        height="62"
                                    />
                                    <div className="texte">
                                        <p>
                                            {convertHtmlToReactDomWithParams(i18nOffline.FT_STEP1)}
                                            <LocalizedNavLink
                                                to={PATH.ACCOUNT_PATH}
                                                title={i18nOffline.FT_STEP1_1}>
                                                {i18nOffline.FT_STEP1_1}
                                            </LocalizedNavLink>
                                        </p>
                                    </div>
                                </div>
                                <div className="cmt-ca-marche-bloc">
                                    <img
                                        alt="heart hand picto"
                                        src={`${STATIC_ROOT}/PictoHeartHand.png`}
                                        width="62"
                                        height="62"
                                    />
                                    <div className="texte">
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18nOffline.FT_STEP2_1
                                            )}
                                            <LocalizedNavLink
                                                to={PATH.FLASHING_TICKET_PATH}
                                                title={i18nOffline.FT_STEP2_2}>
                                                {i18nOffline.FT_STEP2_2}
                                            </LocalizedNavLink>
                                            {i18nOffline.FT_STEP1_3}
                                        </p>
                                    </div>
                                </div>
                                <div className="cmt-ca-marche-bloc">
                                    <img
                                        alt="heart hand picto"
                                        src={`${STATIC_ROOT}/PictoHeartHand.png`}
                                        width="62"
                                        height="62"
                                    />
                                    <div className="texte">
                                        <p>
                                            {convertHtmlToReactDomWithParams(
                                                i18nOffline.FT_STEP3,
                                                PAYMENT_THRESHOLD
                                            )}
                                            <LocalizedNavLink
                                                to={PATH.ACCOUNT_JACKPOT_PATH}
                                                title={i18nOffline.FT_STEP3_1}>
                                                {i18nOffline.FT_STEP3_1}
                                            </LocalizedNavLink>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            );
        } else if (isEbon) {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt=""
                            src={`${STATIC_ROOT}/PictoAccount.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP1, BRAND_NAME_ALT)}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt="Pictobag"
                            src={`${STATIC_ROOT}/PictoBag.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP2, BRAND_NAME)}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt="heart hand picto"
                            src={`${STATIC_ROOT}/PictoHeartHand.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            {HAS_INSTANT_DISCOUNT ? (
                                <p>
                                    {convertHtmlToReactDomWithParams(
                                        i18nEbon.STEP3_INSTANT_DISCOUNT
                                    )}
                                </p>
                            ) : (
                                <p>{convertHtmlToReactDomWithParams(i18nEbon.STEP3)}</p>
                            )}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt="PictoAccount"
                            src={`${STATIC_ROOT}/PictoAccount.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(i18nOnline.STEP1, BRAND_NAME_ALT)}
                            </p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt="Pictobag"
                            src={`${STATIC_ROOT}/PictoBag.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            <p>{convertHtmlToReactDomWithParams(i18nOnline.STEP2)}</p>
                        </div>
                    </div>
                    <div className="cmt-ca-marche-bloc">
                        <img
                            alt="HeartHand picto"
                            src={`${STATIC_ROOT}/PictoHeartHand.png`}
                            width="62"
                            height="62"
                        />
                        <div className="texte">
                            <p>
                                {convertHtmlToReactDomWithParams(
                                    i18nOnline.STEP3,
                                    PAYMENT_THRESHOLD
                                )}
                                <LocalizedNavLink
                                    to={PATH.ACCOUNT_JACKPOT_PATH}
                                    title={i18nOnline.STEP3_1}>
                                    {i18nOnline.STEP3_1}
                                </LocalizedNavLink>
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    };

    render() {
        return (
            <section className="steps">
                <div className="wrapper">{this.getSteps()}</div>
            </section>
        );
    }
}

StepsComponent.propTypes = {
    isOffline: PropTypes.bool,
    showAloOnly: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStoreToProps = state => ({
    i18nOnline: state.i18n.feature.aide.HOW_IT_WORKS.ONLINE,
    i18nOffline: state.i18n.feature.aide.HOW_IT_WORKS.OFFLINE,
    i18nEbon: state.i18n.feature.aide.HOW_IT_WORKS.EBON,
    BRAND_NAME: state.i18n.common.BRAND_NAME,
    BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT
});

export default connect(mapStoreToProps)(StepsComponent);



// WEBPACK FOOTER //
// ./src/components/StepsComponent.js